// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file cos/sprint.proto (package lvdr.v2.cos, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { AiMark } from "../common/aimark_pb";
import { file_common_aimark } from "../common/aimark_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cos/sprint.proto.
 */
export const file_cos_sprint: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp, file_common_aimark]);

/**
 * @generated from message lvdr.v2.cos.FocusSprintStep
 */
export type FocusSprintStep = Message<"lvdr.v2.cos.FocusSprintStep"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: int32 planned_min = 3;
   */
  plannedMin: number;

  /**
   * @generated from field: google.protobuf.Timestamp done_at = 4;
   */
  doneAt?: Timestamp | undefined;

  /**
   * @generated from field: bool drafted = 5;
   */
  drafted: boolean;
};

/**
 * Describes the message lvdr.v2.cos.FocusSprintStep.
 * Use `create(FocusSprintStepSchema)` to create a new message.
 */
export const FocusSprintStepSchema: GenMessage<FocusSprintStep> = /*@__PURE__*/
  messageDesc(file_cos_sprint, 0);

/**
 * @generated from message lvdr.v2.cos.FocusSprint
 */
export type FocusSprint = Message<"lvdr.v2.cos.FocusSprint"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string task_id = 2;
   */
  taskId: string;

  /**
   * @generated from field: string task_title = 3;
   */
  taskTitle: string;

  /**
   * @generated from field: string goal = 4;
   */
  goal: string;

  /**
   * @generated from field: repeated lvdr.v2.cos.FocusSprintStep steps = 5;
   */
  steps: FocusSprintStep[];

  /**
   * @generated from field: int32 current_step = 6;
   */
  currentStep: number;

  /**
   * @generated from field: google.protobuf.Timestamp current_step_started_at = 7;
   */
  currentStepStartedAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp started_at = 8;
   */
  startedAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp sprint_ends_at = 9;
   */
  sprintEndsAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp break_ends_at = 10;
   */
  breakEndsAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp ended_at = 11;
   */
  endedAt?: Timestamp | undefined;

  /**
   * @generated from field: lvdr.v2.cos.FocusSprintPhase phase = 12;
   */
  phase: FocusSprintPhase;

  /**
   * @generated from field: int32 break_min = 13;
   */
  breakMin: number;

  /**
   * @generated from field: int64 version = 14;
   */
  version: bigint;

  /**
   * set while any drafted text remains
   *
   * @generated from field: lvdr.v2.common.AiMark ai_mark = 15;
   */
  aiMark?: AiMark | undefined;

  /**
   * @generated from field: bool goal_drafted = 16;
   */
  goalDrafted: boolean;
};

/**
 * Describes the message lvdr.v2.cos.FocusSprint.
 * Use `create(FocusSprintSchema)` to create a new message.
 */
export const FocusSprintSchema: GenMessage<FocusSprint> = /*@__PURE__*/
  messageDesc(file_cos_sprint, 1);

/**
 * @generated from message lvdr.v2.cos.DraftFocusSprintRequest
 */
export type DraftFocusSprintRequest = Message<"lvdr.v2.cos.DraftFocusSprintRequest"> & {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId: string;

  /**
   * 0 = use the preset
   *
   * @generated from field: int32 length_min = 2;
   */
  lengthMin: number;
};

/**
 * Describes the message lvdr.v2.cos.DraftFocusSprintRequest.
 * Use `create(DraftFocusSprintRequestSchema)` to create a new message.
 */
export const DraftFocusSprintRequestSchema: GenMessage<DraftFocusSprintRequest> = /*@__PURE__*/
  messageDesc(file_cos_sprint, 2);

/**
 * @generated from message lvdr.v2.cos.DraftFocusSprintResponse
 */
export type DraftFocusSprintResponse = Message<"lvdr.v2.cos.DraftFocusSprintResponse"> & {
  /**
   * @generated from field: string goal = 1;
   */
  goal: string;

  /**
   * @generated from field: repeated lvdr.v2.cos.FocusSprintStep steps = 2;
   */
  steps: FocusSprintStep[];

  /**
   * "" | daily_cap | limiter_unavailable | unavailable | confidential | floor_unknown
   *
   * @generated from field: string reason = 3;
   */
  reason: string;

  /**
   * @generated from field: int32 daily_max = 4;
   */
  dailyMax: number;

  /**
   * @generated from field: int32 retry_after_sec = 5;
   */
  retryAfterSec: number;

  /**
   * @generated from field: lvdr.v2.common.AiMark ai_mark = 6;
   */
  aiMark?: AiMark | undefined;

  /**
   * D32
   *
   * @generated from field: repeated lvdr.v2.cos.FocusSprintStep previous_unfinished = 7;
   */
  previousUnfinished: FocusSprintStep[];

  /**
   * D51, for PrepareBriefings
   *
   * @generated from field: string briefing_subject = 8;
   */
  briefingSubject: string;

  /**
   * "" when none; Start echoes it so the record can carry the mark
   *
   * @generated from field: string draft_model_id = 9;
   */
  draftModelId: string;

  /**
   * end of the current deep window
   *
   * @generated from field: google.protobuf.Timestamp deep_until = 10;
   */
  deepUntil?: Timestamp | undefined;

  /**
   * start of the next deep window
   *
   * @generated from field: google.protobuf.Timestamp next_deep = 11;
   */
  nextDeep?: Timestamp | undefined;

  /**
   * @generated from field: int32 preset_length_min = 12;
   */
  presetLengthMin: number;

  /**
   * @generated from field: int32 preset_break_min = 13;
   */
  presetBreakMin: number;

  /**
   * @generated from field: google.protobuf.Timestamp drafted_at = 14;
   */
  draftedAt?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.cos.DraftFocusSprintResponse.
 * Use `create(DraftFocusSprintResponseSchema)` to create a new message.
 */
export const DraftFocusSprintResponseSchema: GenMessage<DraftFocusSprintResponse> = /*@__PURE__*/
  messageDesc(file_cos_sprint, 3);

/**
 * @generated from message lvdr.v2.cos.StartFocusSprintRequest
 */
export type StartFocusSprintRequest = Message<"lvdr.v2.cos.StartFocusSprintRequest"> & {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId: string;

  /**
   * @generated from field: string goal = 2;
   */
  goal: string;

  /**
   * @generated from field: repeated lvdr.v2.cos.FocusSprintStep steps = 3;
   */
  steps: FocusSprintStep[];

  /**
   * @generated from field: int32 length_min = 4;
   */
  lengthMin: number;

  /**
   * @generated from field: int32 break_min = 5;
   */
  breakMin: number;

  /**
   * @generated from field: string draft_model_id = 6;
   */
  draftModelId: string;

  /**
   * @generated from field: string client_request_id = 7;
   */
  clientRequestId: string;

  /**
   * home | block | chat (metric label only)
   *
   * @generated from field: string entry = 8;
   */
  entry: string;

  /**
   * @generated from field: bool goal_drafted = 9;
   */
  goalDrafted: boolean;

  /**
   * @generated from field: google.protobuf.Timestamp drafted_at = 10;
   */
  draftedAt?: Timestamp | undefined;
};

/**
 * Describes the message lvdr.v2.cos.StartFocusSprintRequest.
 * Use `create(StartFocusSprintRequestSchema)` to create a new message.
 */
export const StartFocusSprintRequestSchema: GenMessage<StartFocusSprintRequest> = /*@__PURE__*/
  messageDesc(file_cos_sprint, 4);

/**
 * @generated from message lvdr.v2.cos.StartFocusSprintResponse
 */
export type StartFocusSprintResponse = Message<"lvdr.v2.cos.StartFocusSprintResponse"> & {
  /**
   * @generated from field: lvdr.v2.cos.FocusSprint sprint = 1;
   */
  sprint?: FocusSprint | undefined;
};

/**
 * Describes the message lvdr.v2.cos.StartFocusSprintResponse.
 * Use `create(StartFocusSprintResponseSchema)` to create a new message.
 */
export const StartFocusSprintResponseSchema: GenMessage<StartFocusSprintResponse> = /*@__PURE__*/
  messageDesc(file_cos_sprint, 5);

/**
 * @generated from message lvdr.v2.cos.GetFocusSprintRequest
 */
export type GetFocusSprintRequest = Message<"lvdr.v2.cos.GetFocusSprintRequest"> & {
  /**
   * @generated from field: string task_id = 1;
   */
  taskId: string;
};

/**
 * Describes the message lvdr.v2.cos.GetFocusSprintRequest.
 * Use `create(GetFocusSprintRequestSchema)` to create a new message.
 */
export const GetFocusSprintRequestSchema: GenMessage<GetFocusSprintRequest> = /*@__PURE__*/
  messageDesc(file_cos_sprint, 6);

/**
 * @generated from message lvdr.v2.cos.GetFocusSprintResponse
 */
export type GetFocusSprintResponse = Message<"lvdr.v2.cos.GetFocusSprintResponse"> & {
  /**
   * @generated from field: lvdr.v2.cos.FocusSprint active = 1;
   */
  active?: FocusSprint | undefined;

  /**
   * @generated from field: lvdr.v2.cos.FocusSprint last_on_task = 2;
   */
  lastOnTask?: FocusSprint | undefined;
};

/**
 * Describes the message lvdr.v2.cos.GetFocusSprintResponse.
 * Use `create(GetFocusSprintResponseSchema)` to create a new message.
 */
export const GetFocusSprintResponseSchema: GenMessage<GetFocusSprintResponse> = /*@__PURE__*/
  messageDesc(file_cos_sprint, 7);

/**
 * @generated from message lvdr.v2.cos.UpdateFocusSprintRequest
 */
export type UpdateFocusSprintRequest = Message<"lvdr.v2.cos.UpdateFocusSprintRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: int64 expected_version = 2;
   */
  expectedVersion: bigint;

  /**
   * @generated from field: string goal = 3;
   */
  goal: string;

  /**
   * @generated from field: repeated lvdr.v2.cos.FocusSprintStep steps = 4;
   */
  steps: FocusSprintStep[];

  /**
   * @generated from field: int32 current_step = 5;
   */
  currentStep: number;
};

/**
 * Describes the message lvdr.v2.cos.UpdateFocusSprintRequest.
 * Use `create(UpdateFocusSprintRequestSchema)` to create a new message.
 */
export const UpdateFocusSprintRequestSchema: GenMessage<UpdateFocusSprintRequest> = /*@__PURE__*/
  messageDesc(file_cos_sprint, 8);

/**
 * @generated from message lvdr.v2.cos.UpdateFocusSprintResponse
 */
export type UpdateFocusSprintResponse = Message<"lvdr.v2.cos.UpdateFocusSprintResponse"> & {
  /**
   * @generated from field: lvdr.v2.cos.FocusSprint sprint = 1;
   */
  sprint?: FocusSprint | undefined;

  /**
   * @generated from field: bool conflict = 2;
   */
  conflict: boolean;
};

/**
 * Describes the message lvdr.v2.cos.UpdateFocusSprintResponse.
 * Use `create(UpdateFocusSprintResponseSchema)` to create a new message.
 */
export const UpdateFocusSprintResponseSchema: GenMessage<UpdateFocusSprintResponse> = /*@__PURE__*/
  messageDesc(file_cos_sprint, 9);

/**
 * @generated from message lvdr.v2.cos.EndFocusSprintRequest
 */
export type EndFocusSprintRequest = Message<"lvdr.v2.cos.EndFocusSprintRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: lvdr.v2.cos.FocusSprintEndAction action = 2;
   */
  action: FocusSprintEndAction;
};

/**
 * Describes the message lvdr.v2.cos.EndFocusSprintRequest.
 * Use `create(EndFocusSprintRequestSchema)` to create a new message.
 */
export const EndFocusSprintRequestSchema: GenMessage<EndFocusSprintRequest> = /*@__PURE__*/
  messageDesc(file_cos_sprint, 10);

/**
 * @generated from message lvdr.v2.cos.EndFocusSprintResponse
 */
export type EndFocusSprintResponse = Message<"lvdr.v2.cos.EndFocusSprintResponse"> & {
  /**
   * @generated from field: lvdr.v2.cos.FocusSprint sprint = 1;
   */
  sprint?: FocusSprint | undefined;
};

/**
 * Describes the message lvdr.v2.cos.EndFocusSprintResponse.
 * Use `create(EndFocusSprintResponseSchema)` to create a new message.
 */
export const EndFocusSprintResponseSchema: GenMessage<EndFocusSprintResponse> = /*@__PURE__*/
  messageDesc(file_cos_sprint, 11);

/**
 * Pushed on every phase change. Ids only: the client refreshes.
 *
 * @generated from message lvdr.v2.cos.FocusSprintEvent
 */
export type FocusSprintEvent = Message<"lvdr.v2.cos.FocusSprintEvent"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: lvdr.v2.cos.FocusSprintPhase phase = 2;
   */
  phase: FocusSprintPhase;

  /**
   * @generated from field: int64 version = 3;
   */
  version: bigint;
};

/**
 * Describes the message lvdr.v2.cos.FocusSprintEvent.
 * Use `create(FocusSprintEventSchema)` to create a new message.
 */
export const FocusSprintEventSchema: GenMessage<FocusSprintEvent> = /*@__PURE__*/
  messageDesc(file_cos_sprint, 12);

/**
 * @generated from enum lvdr.v2.cos.FocusSprintPhase
 */
export enum FocusSprintPhase {
  /**
   * @generated from enum value: FOCUS_SPRINT_PHASE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: FOCUS_SPRINT_PHASE_RUNNING = 1;
   */
  RUNNING = 1,

  /**
   * @generated from enum value: FOCUS_SPRINT_PHASE_BREAK = 2;
   */
  BREAK = 2,

  /**
   * @generated from enum value: FOCUS_SPRINT_PHASE_DONE = 3;
   */
  DONE = 3,
}

/**
 * Describes the enum lvdr.v2.cos.FocusSprintPhase.
 */
export const FocusSprintPhaseSchema: GenEnum<FocusSprintPhase> = /*@__PURE__*/
  enumDesc(file_cos_sprint, 0);

/**
 * @generated from enum lvdr.v2.cos.FocusSprintEndAction
 */
export enum FocusSprintEndAction {
  /**
   * @generated from enum value: FOCUS_SPRINT_END_ACTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * running ⇒ break now
   *
   * @generated from enum value: FOCUS_SPRINT_END_ACTION_END_TAKE_BREAK = 1;
   */
  END_TAKE_BREAK = 1,

  /**
   * running ⇒ done now
   *
   * @generated from enum value: FOCUS_SPRINT_END_ACTION_END_NO_BREAK = 2;
   */
  END_NO_BREAK = 2,

  /**
   * break ⇒ done now (skip or end break)
   *
   * @generated from enum value: FOCUS_SPRINT_END_ACTION_END_BREAK = 3;
   */
  END_BREAK = 3,
}

/**
 * Describes the enum lvdr.v2.cos.FocusSprintEndAction.
 */
export const FocusSprintEndActionSchema: GenEnum<FocusSprintEndAction> = /*@__PURE__*/
  enumDesc(file_cos_sprint, 1);

